import { useAuth } from "../contexts/AuthContext";
import { LangSwitch } from "./LangSwitch";

export function Header() {
  const { me, t, managerId, managers, setShowAdmin, setAdminInitialTab } = useAuth();
  if (!me) return null;
  let displayName = me.name;
  if (me.is_admin) {
    if (managerId === "__dept__") displayName = t("header_dept");
    else {
      const m = managers.find(x => x.id === managerId);
      if (m) displayName = m.full_name;
    }
  }
  const maintenanceOn = me.is_admin && me.maintenance_mode === true;
  return (
    <header className="bg-gradient-to-br from-indigo-600 to-violet-600 text-white pt-12 flex-shrink-0">
      <div className="px-5 pb-4 flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-xs opacity-80">KPI Кабинет</div>
          <div className="text-lg font-semibold truncate">{displayName}</div>
        </div>
        {me.is_admin && (
          <button
            onClick={() => setShowAdmin(true)}
            className="bg-white/15 hover:bg-white/25 text-white text-xs font-semibold rounded-full px-3 py-1.5 transition"
          >{t("admin_button")}</button>
        )}
        <LangSwitch />
      </div>
      {maintenanceOn && (
        <button
          onClick={() => { setAdminInitialTab("settings"); setShowAdmin(true); }}
          className="w-full bg-amber-400 hover:bg-amber-300 text-amber-950 text-xs font-semibold py-1.5 px-5 flex items-center justify-center gap-2 transition"
        >
          <span>🔧</span>
          <span>{t("header_maintenance_on")}</span>
          <span className="opacity-70">·</span>
          <span className="opacity-80">{t("header_maintenance_tap")}</span>
        </button>
      )}
    </header>
  );
}
